import React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@material-ui/core';

import { RedeemActiveInviteCompany } from '@vyce/core/src/api/types';

interface Props {
  open: boolean;
  invites: RedeemActiveInviteCompany[];
  onClose: () => void;
}

export const ActiveInvitesDialog: React.FC<Props> = ({ open, invites, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>You were added to new modules</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="textSecondary">
          Here are the companies and modules where your access was added.
        </Typography>
        <List>
          {invites.map(invite => (
            <ListItem key={invite.company_name} alignItems="flex-start">
              <ListItemText
                primary={invite.company_name}
                secondary={
                  invite.models.length
                    ? invite.models.map(model => `${model.model_name} (${model.role})`).join(', ')
                    : 'No modules'
                }
              />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button size="large" onClick={onClose} color="primary" variant="contained">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};
